//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/estateManagement/partyBuilding/partyBuildingContent';
import Tinymce from '@/components/Tinymce';
export default {
  components: {
    Tinymce: Tinymce
  },
  props: ['keyValue', 'showDialog', 'isDetail'],
  data: function data() {
    return {
      rules: {
        title: [{
          required: true,
          message: '请输入党建内容标题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 20,
          message: '长度在 1 到 20 个字符',
          trigger: 'change'
        }],
        remark: [{
          required: true,
          message: '请输入党建内容摘要',
          trigger: 'blur'
        }, {
          min: 1,
          max: 200,
          message: '长度在 1 到 200 个字符',
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: '请输入党建内容',
          trigger: 'change'
        }, {
          min: 1,
          max: 30000,
          message: '长度在 1 到 30000 个字符',
          trigger: 'change'
        }]
      },
      readonly: 1,
      toolbar: [''],
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          var that = _this;
          setTimeout(function () {
            that.$refs['editor'].setContent(that.childData.content);
            that.$refs['viewer'].setContent(that.childData.content);
          }, 100);
        });
      } else {
        this.childData = {};
        var that = this;
        setTimeout(function () {
          that.$refs['editor'].setContent('');
          that.$refs['viewer'].setContent('');
        }, 100);
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (!_this2.childData.content) {
            _this2.Alert({
              alertType: 'valid',
              message: '党建内容不能为空'
            });

            return;
          }

          _this2.childData.publishStatus = 0;

          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'repairAdd');
    }
  }
};